import React from 'react';
import { Box, useTheme } from '@mui/material';
import ExpandIcon from '@square-icons/react/24/UI/chevron-down';
import {
  ShopAccordion,
  ShopAccordionSummary,
  ShopAccordionDetails,
} from 'components/common/shop_accordion';
import RichTextContent from 'components/common/contentful/rich_text_content';

const SpecificationAccordionRow = (props) => {
  const { title, content, children, ...rootProps } = props;

  const theme = useTheme();

  return (
    <ShopAccordion {...rootProps}>
      <ShopAccordionSummary expandIcon={<ExpandIcon />}>
        <Box fontSize="20px" fontWeight={theme.type.fontWeight.medium}>
          {title}
        </Box>
      </ShopAccordionSummary>
      <ShopAccordionDetails>
        {children ? (
          children
        ) : (
          <RichTextContent
            content={content}
            spacing={0}
            whiteSpace="pre-wrap"
          />
        )}
      </ShopAccordionDetails>
    </ShopAccordion>
  );
};

export default SpecificationAccordionRow;
